<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini" inline>
            <el-form-item  label="开票时间" >{{formData.invoiceDate}}</el-form-item>
            <el-form-item  label="发票代码" >{{formData.invoiceCode}}</el-form-item>
            <el-form-item  label="发票号码" >{{formData.invoiceNum}}</el-form-item>
            <el-form-item  label="全电发票号码" >{{formData.electronicNumber}}</el-form-item>
            <el-form-item  label="销售方" >{{formData.sellerName}}</el-form-item>
            <el-form-item  label="购买方" >{{formData.buyerName}}</el-form-item>
            <el-form-item  label="发票状态" >{{formData.invoiceStatus}}</el-form-item>
            <el-form-item  label="关联蓝字发票号" v-if="formData.invoiceType==2">{{formData.relativeBlueCode}}</el-form-item>

            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
                <el-table-column  label="序号" align="center" type="index" width="45px"></el-table-column>
                <el-table-column  :label="$t('form_product_name')" align="center" prop="productName" ></el-table-column>
                <el-table-column  label="规格型号" align="center" prop="model" ></el-table-column>
                <el-table-column  label="计量单位" align="center" prop="measurementUnit" ></el-table-column>
                <el-table-column  label="数量" align="center" prop="count" ></el-table-column>
                <el-table-column  label="无税单价" align="center" prop="taxlessPrice" ></el-table-column>
                <el-table-column  label="无税金额" align="center" prop="taxlessAmount" ></el-table-column>
                <el-table-column  label="税率" align="center" prop="taxRate" ></el-table-column>
                <el-table-column  label="税额" align="center" prop="taxAmount" ></el-table-column>
            </el-table>
            <div class="flex_b w100 marT10">
                <div class="flex w50 alc">
                    <span class="marr4 font14">价税合计（大写）</span>
                    <span class="marr4 font14">{{DtotalPrice}}</span>
                </div>
                <div class="w50 txtE">
                    <span class="marr4 font14">{{'（小写）'+totalPrice}}</span>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的

                    }
                },
                baseerp:'',
                canEdit:false,
                formData:{
                },
                tableData:[],
                tableHeight:0,
                DtotalPrice:'',
                totalPrice:0,
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.recordId;
                        this.formData=JSON.parse(JSON.stringify(this.data));


                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.withInvoiceServer();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-105;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            // editForm(){
            //     this.canEdit=true
            // },


            async withInvoiceServer(){
                let param={
                    serviceType:2,
                    detailParam:{
                        recordId:this.formData.recordId
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.productList;
                    //价税合计
                    let tp = 0;
                    let ts = 0;
                    this.tableData.map(item=>{
                        tp += item.taxAmount;
                        ts += item.taxlessAmount;
                    })
                    let num = this.keepTwoDecimal(tp+ts);
                    this.totalPrice = this.returnFloat(num);
                    this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 100) / 100;//保留两位

                }
                return result;
            },
            convertToChineseCapital(val){
                let cnNums = ['零','壹','贰','叁','肆','伍','陆','柒','捌','玖'] //汉字数字
                let cnIntRadice = ['','拾','佰','仟']  //基本单位
                let cnIntUnits = ['元','万','亿','兆'] //整数部分扩展单位
                let cnDecUnits = ['角','分','毫','厘'] //小数部分扩展单位
                // let cnInteger = '整'
                let cnIntLast = '元'
                let integerNum  //金额的整数部分
                let decimalNum  //金额的小数部分
                let chineseStr = '' //输出的中文金额字符串
                let parts; //分离金额后用的数组
                if(val== ''){
                    return ''
                }
                if(val == 0){
                    // return cnNums[0] + cnIntLast + cnInteger
                    return cnNums[0] + cnIntLast
                }
                // 转化为字符串
                val = val + ''
                if(val.indexOf('.') == -1){
                    integerNum = val
                    decimalNum = ''
                }else{
                    parts = val.split('.')
                    integerNum = parts[0]
                    decimalNum = parts[1].substr(0,4)
                }
                // 获取整形部分转化
                if(parseInt(integerNum,10)>0){
                    let zeroCount = 0
                    let IntLen = integerNum.length
                    for(let i=0;i<IntLen;i++){
                        let n = integerNum.substr(i,1)
                        let p = IntLen - i - 1
                        let q = p / 4
                        let m = p % 4
                        if(n == 0){
                            zeroCount ++
                        }else{
                            if(zeroCount > 0){
                                chineseStr += cnNums[0]
                            }
                            // 归0
                            zeroCount = 0
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                        }
                        if(m==0 && zeroCount<4){
                            chineseStr += cnIntUnits[q]
                        }

                    }
                    // chineseStr += cnIntLast
                }
                // 小数部分
                if(decimalNum != ''){
                    let decLen = decimalNum.length
                    for(let i=0;i<decLen;i++){
                        let n = decimalNum.substr(i,1)
                        if(n != 0){
                            chineseStr+=cnNums[Number(n)]+cnDecUnits[i]
                        }
                    }
                }
                if(chineseStr == ''){
                    // chineseStr += cnNums[0]+ cnIntLast + cnInteger
                    chineseStr += cnNums[0]+ cnIntLast
                }else if(decimalNum == ''){
                    // chineseStr += cnInteger
                    chineseStr += ''
                }
                return chineseStr
            },
            returnFloat(num) {
                num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
                if (num.indexOf(".") !== -1) {
                    let [integerPart, decimalPart] = num.split(".");

                    if (decimalPart.length > 2) {
                        decimalPart = decimalPart.substring(0, 2);
                    } else if (decimalPart.length === 1) {
                        decimalPart += "0";
                    }

                    num = `${integerPart}.${decimalPart}`;
                } else {
                    num += ".00";
                }

                return num;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
    .w50{
        width: 50%;
    }
    .alc{
        align-items: center;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .txtE{
        text-align: end;
    }
</style>